export const relayStateCommandEnum = {
  ON: 'ON',
  OFF: 'OFF',
} as const

export type RelayStateCommandEnum = (typeof relayStateCommandEnum)[keyof typeof relayStateCommandEnum]

export type RelayStateCommand = RelayStateCommandEnum